import crudFactory from "../crudFactory.ts";

const MODEL = "visibilities/lookup";

const COMMON_CRUD_APIs = crudFactory(MODEL);

export default { ...COMMON_CRUD_APIs };
